<template>
  <div>
    <contact-section />
  </div>
</template>

<script>
import ContactSection from "@/components/ContactSection.vue"

export default {
  components: { 
    ContactSection 
    }
}
</script>

<style>

</style>